import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Icon, Card, Header, Image, Breadcrumb, List} from 'semantic-ui-react';
import {Helmet} from "react-helmet";

import CustomDivider from '../../components/extras/CustomDivider';
import {connect} from "react-redux";

let icon_contacts = require('../../img/icons/contacts.svg');
let icon_products = require('../../img/icons/products.svg');
let icon_sales = require('../../img/icons/money.svg');
let icon_expense = require('../../img/icons/expense.svg');

class ReportsDash extends Component {

    render() {
        return (
            <div>
                <Helmet>
                    <title>Informes - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Informes</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                <Card.Group stackable centered>
                    <Card>
                        <Card.Content>
                            <Header as='h3' icon>
                                <Icon><Image src={icon_sales} height={48} alt='logo'/></Icon>
                                Ventas y Utilidades
                            </Header>
                            <List divided>
                                <List.Item as={Link} to='/reports/sales'>Gráficos de Ventas</List.Item>
                                <List.Item as={Link} to='/reports/utilities'>Gráficos de Utilidades</List.Item>
                                <List.Item as={Link} to='/reports/income'>Reporte de Ingresos</List.Item>
                                <List.Item as={Link} to='/reports/taxes'>Reporte de Impuestos</List.Item>
                                <List.Item as={Link} to='/reports/categories'>Ventas por Categorías</List.Item>
                                <List.Item as={Link} to='/reports/cancel-sales'>Ventas Anuladas</List.Item>
                                <List.Item as={Link} to='/reports/sale-types'>Informe por Medios de Pago</List.Item>
                                <List.Item as={Link} to='/reports/channel-sales'>Reporte por Canales de Venta</List.Item>
                                <List.Item as={Link} to='/reports/tips'>Reporte de propinas</List.Item>
                            </List>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <Header as='h3' icon>
                                <Icon><Image src={icon_expense} height={48} alt='logo' /></Icon>
                                Gastos y Descuentos
                            </Header>
                            <List divided>
                                <List.Item as={Link} to='/reports/expenses'>Gráficos de Gastos</List.Item>
                                <List.Item as={Link} to='/reports/egress'>Reporte de Egresos</List.Item>
                                <List.Item as={Link} to='/reports/expense-types'>Informe por Tipos de Gasto</List.Item>
                                <List.Item as={Link} to='/reports/discounts'>Reporte de Descuentos</List.Item>
                            </List>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <Header as='h3' icon>
                                <Icon><Image src={icon_products} height={48} alt='logo'/></Icon>
                                Inventarios y Productos
                            </Header>
                            <List divided>
                                <List.Item as={Link} to='/reports/stock-products'>Inventario de Productos</List.Item>
                                <List.Item as={Link} to='/reports/stock-ingredients'>Inventario de Ingredientes</List.Item>
                                <List.Item as={Link} to='/reports/stock-branch-office'>Inventario por Sucursal</List.Item>
                                <List.Item as={Link} to='/reports/product-sales'>Venta de Productos</List.Item>
                                <List.Item as={Link} to='/reports/report-sale-products'>Reporte de Productos Vendidos</List.Item>
                                <List.Item as={Link} to='/reports/products-discharged'>Productos Dados de Baja</List.Item>
                            </List>
                        </Card.Content>
                    </Card>
                    <Card>
                        <Card.Content>
                            <Header as='h3' icon>
                                <Icon><Image src={icon_contacts} height={48} alt='logo'/></Icon>
                                Contáctos
                            </Header>
                            <List divided>
                                <List.Item as={Link} to='/reports/clients'>Clientes</List.Item>
                            </List>
                        </Card.Content>
                    </Card>
                </Card.Group>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        suscription: state.get('suscription'),
    };
};

export default connect(
    mapStateToProps
)(ReportsDash);



// WEBPACK FOOTER //
// ./src/containers/reports/ReportsDash.js